import axiosInstance, {
  errorHandler,
  totalAccountsBranchTypeAdapter,
} from "./api";
import querystring from "query-string";
import { SortAdapter, AssetsAdapter } from "./utils";

// IrohaAccountResource.getAllIrohaAccountSummary
const getAllAccountsSummary = axios => ({
  type = "ALL",
  branch = "ALL",
} = {}) =>
  axios
    .get(
      `/tps/api/iroha-account-summary?${querystring.stringify({
        type,
        branch,
      })}`,
    )
    .then(({ data }) => data)
    .catch(errorHandler);

// FstIrohaAccountResource.getFstIrohaAccountWithIdentity
const getAccountDetails = axios => id =>
  axios
    .get(`/tps/api/fst-iroha-accounts/${id}`)
    .then(({ data }) => AccountDetailsAdapter(data))
    .catch(errorHandler);

// TODO: Add permission
const getIrohaAccountDetails = axios => accountId =>
  axios
    .get(`/authservice/api/v1/user/searchIrohaAccByAccountId`, {
      params: { accountId },
    })
    .then(({ data }) => data.irohaAccountInfo)
    .catch(errorHandler);

// FstIrohaAccountResource.findIrohaAccountByPhone
const getAccountDetailsByPhone = axios => phone =>
  axios
    .get(`/tps/api/fst-iroha-accounts/find-by-phone/${phone}`)
    .then(({ data }) => AccountDetailsAdapter(data))
    .catch(errorHandler);

const AccountDetailsAdapter = ({ sex = "", ...data }) => ({
  sex: sex && sex.toLowerCase(),
  ...data,
});

// FstIrohaAccountResource.getAllFstIrohaAccounts
const getListUserUnderDomain = axios => ({
  page,
  size,
  filter = "",
  sort = "",
  type = "ALL",
  branch,
} = {}) =>
  axios
    .get("/tps/api/list-iroha-account", {
      params: {
        page,
        size,
        filter,
        sort: SortAdapter(sort),
        branch: totalAccountsBranchTypeAdapter(branch),
        type,
      },
    })
    .then(({ data }) => ({
      data: data.accounts.map(AssetsAdapter),
      total: data.totalCount,
    }))
    .catch(errorHandler);

// NO permission (ParticipantBankResource.getParticipantBank)
const getLogo = axios => participantCode =>
  axios
    .get(`/tps/api/participant-banks/code/${participantCode}`)
    .then(({ data }) => ({
      data,
    }))
    .catch(errorHandler);

// NO permission (IrohaAccountResource.currencyMap)
const getCurrencies = axios => () =>
  axios
    .get(`/tps/api/currency-map/`)
    .then(({ data }) => ({
      data,
    }))
    .catch(errorHandler);

// BalanceInquiryResource.getAllBalances
const getMainAccountBalance = axios => partCode =>
  axios
    .get(`/tps/api/balance-inquiry/fast-core/${partCode}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// ParticipantBankBranchResource.addIrohaAccountsToBranch
const putAccountsIntoBranch = axios => ({ branchId, irohaAccounts = [] }) =>
  axios
    .put("/tps/api/participant-bank-branches/add-accounts", {
      branchId,
      irohaAccounts,
    })
    .then(({ data }) => data)
    .catch(errorHandler);

// ParticipantBankBranchResource.removeIrohaAccountsFromBranch
const putAccountsOutOfBranch = axios => ({ branchId, irohaAccounts = [] }) =>
  axios
    .put("/tps/api/participant-bank-branches/remove-accounts", {
      branchId,
      irohaAccounts,
    })
    .then(({ data }) => data)
    .catch(errorHandler);

// No premission (ParticipantBankBranchResource.getAllParticipantBankBranches)
const getBranchesList = axios => () =>
  axios
    .get("/tps/api/participant-bank-branches")
    .then(({ data }) => data)
    .catch(errorHandler);

export default {
  getAllAccountsSummary: getAllAccountsSummary(axiosInstance),
  getAccountDetails: getAccountDetails(axiosInstance),
  getAccountDetailsByPhone: getAccountDetailsByPhone(axiosInstance),
  getIrohaAccountDetails: getIrohaAccountDetails(axiosInstance),
  getListUserUnderDomain: getListUserUnderDomain(axiosInstance),
  getLogo: getLogo(axiosInstance),
  getMainAccountBalance: getMainAccountBalance(axiosInstance),
  putAccountsIntoBranch: putAccountsIntoBranch(axiosInstance),
  putAccountsOutOfBranch: putAccountsOutOfBranch(axiosInstance),
  getBranchesList: getBranchesList(axiosInstance),
  getCurrencies: getCurrencies(axiosInstance),
};
